module.exports = __webpack_public_path__ + "img/2.7cc92146.png";